import type { WorkbookDefinition } from '@erp/shared-types';
import { workbookDependencies } from '@erp/workbooks';

/**
 * The Sources and Worksheets a Worksheet can read (as its input or a
 * Lookup's source) without a circular reference: every one but itself and
 * the Worksheets that already read it, directly or through others.
 */
export function worksheetReadableTables(
  definition: WorkbookDefinition,
  sheetId: string,
): { id: string; name: string }[] {
  const dependencies = workbookDependencies(definition);
  const readsSheet = new Map<string, boolean>();
  const reads = (id: string, seen: Set<string>): boolean => {
    const known = readsSheet.get(id);
    if (known !== undefined) return known;
    if (seen.has(id)) return false;
    seen.add(id);
    const result = (dependencies.get(id) ?? []).some(
      (upstream) => upstream === sheetId || reads(upstream, seen),
    );
    readsSheet.set(id, result);
    return result;
  };
  return [...definition.sources, ...definition.sheets].filter(
    (item) => item.id !== sheetId && !reads(item.id, new Set()),
  );
}
